export default __webpack_public_path__ + "assets/USBank-86ddf280939a7c016d2e38d52b0bc378.svg";